<template>
    <div class="page-sidebar page-sidebar-fixed">
        <!-- .sidebar-header -->
        <header class="sidebar-header d-sm-none">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item active">
                        <a href="#" onclick="Looper.toggleSidebar()">
                            <em class="breadcrumb-icon fa fa-angle-left mr-2"></em>Back</a>
                    </li>
                </ol>
            </nav>
        </header><!-- /.sidebar-header -->
        <!-- .sidebar-section-fill -->
        <div class="sidebar-section-fill">
            <!-- .calendar-list -->
            <div id="calendar-list">
                <div class="fc-view-container" >
                    <div class="fc-view fc-listMonth-view fc-list-view card card-reflow">
                        <div class="fc-scroller" style="overflow: hidden auto; min-height: 200px;">
                            <table class="fc-list-table table" aria-label="List">
                                <thead>
                                  <th id="" style="display:none"></th>
                                </thead>
                                <tbody>
                                <template v-for="(event,i) in sortEvent" >
                                  <template v-if="event.title !== ''">
                                    <tr class="fc-list-heading" :data-date="getDate(event)" v-if="getDate(sortEvent[i]) !== getDate(sortEvent[i-1])">
                                        <td class="bg-light" colspan="4">
                                            <span class="fc-list-heading-main">{{getFormattedDate(event)}}</span>
                                            <span class="fc-list-heading-alt">{{getDay(event)}}</span>
                                        </td>
                                    </tr>
                                    <tr class="fc-list-item">
                                        <td class="fc-list-item-time " style="white-space:pre-wrap;width:50%">
                                          {{event.extendedProps.duration_hours !== undefined  && event.extendedProps.duration_hours  > 0? event.extendedProps.duration_hours+"h": ""}}{{event.extendedProps.duration_minutes !== undefined && event.extendedProps.duration_minutes > 0? event.extendedProps.duration_minutes+"m" :""}} #
                                          {{formatHours(event.extendedProps.check_in)}} - {{formatHours(event.extendedProps.check_out)}}
                                        </td>
                                        <td class="fc-list-item-marker ">
                                            <span class="fc-event-dot" :style="{backgroundColor: getRandomColor()}"></span>
                                        </td>
                                        <td class="fc-list-item-title ">
                                          <div class="d-flex align-items-center">
                                            <span class="mr-auto">{{event.title}}</span>
                                            <div class="dropdown" v-if="$parent.checkStatus() && ($parent.action_button.edit || $parent.action_button.delete)">
                                              <a href="#" data-toggle="dropdown" aria-expanded="true">
                                                <em class="fa fa-ellipsis-h"></em>
                                              </a>
                                              <div class="dropdown-menu dropdown-menu-right">
                                                <div class="dropdown-arrow mr-n1"></div>
                                                <button class="dropdown-item" type="button" v-show="$parent.action_button.edit" @click="edit(event)">Edit</button>
                                                <button class="dropdown-item" type="button" v-show="$parent.action_button.delete" @click="deleteItem(event, $event)">Delete</button>
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                    </tr>
                                  </template>
                                </template>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div><!-- /.calendar-list -->
        </div><!-- /.sidebar-section-fill -->
      <b-modal id="modal-delete" hide-backdrop content-class="shadow" ref="modal-delete" title="Delete" @ok="deleteTimeRecording" ok-title="Delete" ok-variant="danger">
        <p class="my-2">
          Are you sure delete this item ?
        </p>
      </b-modal>
    </div><!-- /.page-sidebar -->
</template>

<script>
import {format} from 'date-fns'
import {BModal} from "bootstrap-vue";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";

export default {
  name: "CalendarSidebar",
  props: {
    events: {
      type: Array,
      required: true
    },
    weekendsVisible: {
      type: Boolean,
      required: true
    },
  },
  data(){
    return {
      delete_item : {}
    }
  },
  components: {
    BModal,
  },
  computed: {
    weekendsVisibleCheckbox: {
      get() {
        return this.weekendsVisible
      },
      set(value) {
        return this.$emit('set-weekends-visible', value)
      }
    },
    sortEvent() {
      let arr_event = this.events
      arr_event.sort(function (a, b) {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(a.date) - new Date(b.date);
      });
      return arr_event
    }
  },
  methods: {
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    isAllDay(event) {
      return (event.allDay !== undefined) ? event.allDay : false
    },
    getFormattedDate(event) {
      const date = event.date || event.start
      if (date === undefined) {
        return ''
      }
      return format(date, 'MMM d, yyyy')
    },
    getDate(event) {

      if (event === undefined) {
        return ''
      }

      const date = event.date || event.start
      if (date === undefined) {
        return ''
      }
      return !isNaN(Date.parse(date)) ? '' : format(date, 'yyyy-MM-dd')
    },
    getDay(event) {
      const date = event.date || event.start
      if (date === undefined) {
        return ''
      }
      return format(date, 'iiii')
    },
    edit(payload) {
      let event = payload
      this.$parent.onEventClick({event})
    },
    deleteItem(item){
      this.delete_item = item
      this.$refs["modal-delete"].show()
    },
    deleteTimeRecording() {
      AxiosCall.Delete(urlApi.time_recording.delete_data+"/"+this.delete_item.id).then(res=>{
        this.$parent.successMessage(res.message)
        this.$parent.$refs["modal-update"].hide()
        return this.$parent.deleteEvent(this.delete_item.id)
      }).catch(err =>{
        this.errorMessage(err.message)
      })
    },
    formatHours(val){

      if(val !== null){
        let arr = val.split(":")
        if(arr.length > 2){
          val = arr[0]+":"+arr[1]
        }

      }

      return val
    }
  }
}
</script>

<style scoped>
    .fc-list-view {
        border:none !important;
    }
    .fc-list-heading-alt{
        float: right;
    }

</style>